import { Typography } from "@/frontend/shared/ui/Typography";
import styles from "./Sidebar.module.scss";
import clsx from "clsx";

export function Sidebar({
  currentSection,
  setCurrentSection
}: {
  currentSection: string;
  setCurrentSection: (section: string) => void;
}) {
  return (
    <div className={styles.container}>
      <div className={styles.block}>
        <Typography variant="label-5" color="greyscale500" className={styles.sectionTitle}>
          Personal
        </Typography>
        <Typography
          className={clsx(styles.section, currentSection === "Profile" && styles.active)}
          variant="label-4"
          color="greyscale800"
          onClick={() => setCurrentSection("Profile")}
        >
          Profile
        </Typography>
      </div>
      <div className={styles.block}>
        <Typography variant="label-5" color="greyscale500" className={styles.sectionTitle}>
          Organization
        </Typography>
        <Typography
          className={clsx(styles.section, currentSection === "Settings" && styles.active)}
          variant="label-4"
          color="greyscale800"
          onClick={() => setCurrentSection("Settings")}
        >
          Settings
        </Typography>
        <Typography
          className={clsx(styles.section, currentSection === "Users" && styles.active)}
          variant="label-4"
          color="greyscale800"
          onClick={() => setCurrentSection("Users")}
        >
          Users
        </Typography>
        <Typography
          className={clsx(styles.section, currentSection === "Experts" && styles.active)}
          variant="label-4"
          color="greyscale800"
          onClick={() => setCurrentSection("Experts")}
        >
          Experts
        </Typography>
        {/* <Typography
          className={clsx(styles.section, currentSection === "Integrations" && styles.active)}
          variant="label-4"
          color="greyscale800"
          onClick={() => setCurrentSection("Integrations")}
        >
          Integrations
        </Typography>
        <Typography
          className={clsx(styles.section, currentSection === "Billing" && styles.active)}
          variant="label-4"
          color="greyscale800"
          onClick={() => setCurrentSection("Billing")}
        >
          Billing
        </Typography> */}
      </div>
      {/* <div className={styles.block}>
        <Typography variant="label-5" color="greyscale500">
          Pipeline
        </Typography>
        <Typography
          className={clsx(styles.section, currentSection === "ApplicationForm" && styles.active)}
          onClick={() => setCurrentSection("ApplicationForm")}
          variant="label-4"
          color="greyscale800"
        >
          Application Form
        </Typography>
      </div> */}
    </div>
  );
}
